export type AppLanguage = 'pt' | 'en';

export const AppLanguageCookieKey = 'AppLanguage';
